'use client';

import { VariableBlinqLogo } from '@components/BlinqAssets';
import { useSideNav } from '@components/SideNav2/context';
import { faChevronsLeft, faChevronsRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Box, Group, Tooltip } from '@mantine/core';

import {
  expandButtonStyle,
  logoContainerStyle,
  logoFullStyle,
  logoIconStyle,
  toggleButtonStyle,
} from './styles.css';

export function Logo() {
  const { isExpanded, isHovered, toggleExpanded } = useSideNav();

  return (
    <Box mb="lg" pt="xl" px={isExpanded ? 'md' : 'sm'}>
      <Group justify={isExpanded ? 'space-between' : 'center'} align="center" wrap="nowrap">
        <div className={logoContainerStyle}>
          <VariableBlinqLogo iconOnly className={logoIconStyle({ visible: !isExpanded })} />
          <VariableBlinqLogo className={logoFullStyle({ visible: isExpanded })} />
          <div className={expandButtonStyle({ visible: !isExpanded && isHovered })}>
            <Tooltip label="Expand sidebar" position="right">
              <ActionIcon
                variant="subtle"
                color="gray"
                size="md"
                onClick={toggleExpanded}
                aria-label="Expand sidebar"
              >
                <FontAwesomeIcon icon={faChevronsRight} />
              </ActionIcon>
            </Tooltip>
          </div>
        </div>

        {/* Collapse button - only when expanded */}
        {isExpanded && (
          <Tooltip label="Collapse sidebar" position="right" disabled={!isHovered}>
            <ActionIcon
              className={toggleButtonStyle({ visible: isHovered })}
              variant="subtle"
              color="gray"
              size="md"
              onClick={toggleExpanded}
              aria-label="Collapse sidebar"
            >
              <FontAwesomeIcon icon={faChevronsLeft} />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    </Box>
  );
}
